import React from 'react';
import PlansModal from '../components/ui/PlansModal';
import { useUIStore } from '../stores/uiStore';
import { useCurrentUser } from '../hooks/queries/useCurrentUser';

// Global Plans Modal state now lives in the Zustand UI store. This module keeps
// the `usePlansModal()` + `<PlansModalProvider>` API stable for existing callers.
export const usePlansModal = () => {
  const openPlansModal = useUIStore((s) => s.openPlansModal);
  const closePlansModal = useUIStore((s) => s.closePlansModal);
  return { openPlansModal, closePlansModal };
};

export const PlansModalProvider = ({ children }) => {
  const isOpen = useUIStore((s) => s.plansModalOpen);
  const setPlansModalOpen = useUIStore((s) => s.setPlansModalOpen);
  // Shared, deduped current-user query — cached app-wide, so opening the modal
  // reuses the already-fetched user instead of a fresh round-trip.
  const { data: user } = useCurrentUser({ enabled: isOpen });

  return (
    <>
      {children}
      <PlansModal
        open={isOpen}
        onOpenChange={setPlansModalOpen}
        user={user || null}
        onSuccess={() => window.location.reload()}
      />
    </>
  );
};
